// return true if they are amount
export const NUM_TYPE_COLS = {
    populationSize: false,
    revenue: true,
    revenueDelayImpact: true,
}
